import gql from 'graphql-tag';

export const ADDRESS_LOOKUP = gql`
  query addressLookup($zipcode: String!, $houseNumber: String!) {
    addressLookup(zipcode: $zipcode, houseNumber: $houseNumber) {
      street
      city
      numberFirst
    }
  }
`;

export const ADDRESS_SUGGESTIONS = gql`
  query addressSuggestions($query: String!) {
    addressSuggestions(query: $query) {
      id
      label
    }
  }
`;

export const ADDRESS_SUGGESTION_DETAILS = gql`
  query addressSuggestionDetails($id: ID!) {
    addressSuggestionDetails(id: $id) {
      street
      city
      numberFirst
      zipcode
      houseNumber
    }
  }
`;
